<div class="card-body p-0 pt-4">
    <div class="d-flex justify-content-between pb-2">
        <!-- <button class="btn btn-sm btn-primary">Adicionar Projeto</button> -->
        <h4 class="card-title mb-0 flex-grow-1 mb-3">Histórico de Mensagens</h4>
    </div>
    <div class="card">
        <div class="card-header align-items-center d-flex justify-content-between">
            
                <div class="d-flex">
                    <div>

                        <button (click)="voltar()" type="button" class="btn btn-soft-link waves-effect" style="margin-right: 25px;">Voltar</button>
                    </div>
                    
                    <select class="form-select form-select-sm mb-0 my-n1" (change)="onFeiraSelecionada($event)">
                        <option value="" selected disabled>Selecione uma feira</option>
                        <option *ngFor="let feira of listaFeiras" [value]="feira.historicoMensagemId">
                            {{ feira.feira }}
                        </option>
                    </select>
                </div>
                <button type="button" class="btn btn-sm btn-primary" (click)="abrirModalAdicionarMensagem()">Adicionar Mensagem</button>
           
        </div><!-- end card header -->

        <div class="card-body text-muted">
            @if (loading) {
            <tr class="d-flex justify-content-center">
                <td colspan="7" class="text-center position-relative">
                    <div class="d-flex justify-content-center align-items-center" style="height: 150px">
                        <span class="spinner-border" style="width: 3rem; height: 3rem" role="status"
                            aria-hidden="true"></span>
                    </div>
                </td>
            </tr>
            }@else {

            <div ngbAccordion [closeOthers]="true">
                @for (mensagem of listaMensagens; track $index) {
                <div ngbAccordionItem>
                    <h2 ngbAccordionHeader>
                        <button ngbAccordionButton class="w-100 text-start">
                            <div class="d-flex align-items-start w-100">
                                <div class="flex-shrink-0 user-img away align-self-center me-3 mr-2">
                                    <i *ngIf="mensagem.mensagemRelevante === true" class="mdi mdi-star text-warning" title="Mensagem Relevante"></i>
                                    <i *ngIf="mensagem.mensagemRelevante !== true" class="fab fa-rocketchat"></i>
                                    <span class="user-status"></span>
                                </div>

                                <div class="flex-grow-1 overflow-hidden">
                                    <h5 class="text-truncate font-size-14 mb-1">{{ mensagem.atendente }}</h5>
                                    <p class="text-truncate mb-0">
                                        {{ mensagem.mensagem }}
                                    </p>
                                </div>
                                <div class="flex-shrink-0">
                                    <div class="font-size-11">em {{mensagem.dataMensagem | date: 'dd/MM/yyyy hh:mm'}}</div>
                                </div>
                            </div>
                        </button>
                    </h2>
                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-template>
                                <div class="d-flex align-items-start">
                                    <div class="flex-shrink-0 user-img away align-self-center me-3 mr-2">
                                        <i *ngIf="mensagem.mensagemRelevante === true" class="mdi mdi-star text-warning" title="Mensagem Relevante"></i>
                                        <i *ngIf="mensagem.mensagemRelevante !== true" class="fab fa-rocketchat"></i>
                                        <span class="user-status"></span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="font-size-14 mb-2">{{ mensagem.atendente }}</h5>
                                        <p class="mb-2">
                                            {{ mensagem.mensagem }}
                                        </p>
                                        <div class="font-size-11 text-muted">em {{mensagem.dataMensagem | date: 'dd/MM/yyyy hh:mm'}}</div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
                }
            </div>

            }
        </div><!-- end card-body -->
    </div>
</div>